import axios from ".";

/**
 * Upload a sheet file (CSV, XLS, or XLSX) for a batch
 */
export const uploadSheet = async (
  batchId: string,
  file: File
): Promise<{
  success: boolean;
  message?: string;
}> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `/sheet/upload?batch_id=${batchId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data.data;
};

/**
 * Get sheet data with column descriptions for a batch
 */
export const getSheetData = async (batchId: string) => {
  return axios.get(`/sheet/sheet-data?batch_id=${batchId}`);
};
